export const OPTIONAL_RATE_FIELD_TITLES = ['Surcharges', 'Extra adult amount', 'Adult rollaway charge', 'Resort fee', 'Fees', 'Other fees']
